import ApiClient from "../ApiClient";

const ZoomServices = {

async exchangeCode(code) {
  const resp = await ApiClient.post("/zoom/oauth/token", { code });
  return resp.data.data;
},

async getConnectionStatus() {
  const resp = await ApiClient.get("/zoom/oauth/status");
  return resp.data.data;
},

async disconnect() {
  const resp = await ApiClient.delete("/zoom/oauth/disconnect");
  return resp.data.data;
},

async createUserMeeting(payload) {
  return ApiClient.post(
    "/zoom/user/meetings",
    payload
  ).then(r => r.data.data);
},

  async updateUserMeeting(meetingId, payload) {
  return ApiClient.patch(
    `/zoom/user/meetings/${encodeURIComponent(meetingId)}`,
    payload
  ).then(r => r.data.data);
},

  // Create instant or scheduled Zoom meeting
  async createMeeting(payload) {
    const resp = await ApiClient.post("/zoom/meetings", payload);
    return resp.data;
  },

  // Generate Zoom SDK signature
  async generateSignature(payload) {
    const resp = await ApiClient.post("/zoom/signature", payload);
    return resp.data;
  },

  // (future use) Get scheduled meetings
  async getUpcomingMeetings () {
    const resp = await ApiClient.get("/zoom/meetings/upcoming");
    return resp.data.data;
  },

  async deleteMeeting(meetingId) {
    return ApiClient.delete(`/zoom/meetings/${meetingId}`)
    .then(r => r.data);
  },

  async deleteExpiredMeetings() {
          return ApiClient.delete(`/zoom/meetings`).then(r => r.data);
      },

};

export default ZoomServices;
